import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class IntegrationKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(requestConfig) {
        return this.get(`/integrations`, requestConfig);
    }
    read(entityId, requestConfig) {
        return this.get(`/integrations/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/integrations', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/integrations/${entity.integrationId}`, entity, requestConfig);
    }
    delete(entityId, requestConfig) {
        return this.del(`/integrations/${entityId}`, requestConfig);
    }
}
//# sourceMappingURL=integration.js.map